"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelDifficultyLevelSchema = void 0;
exports.parsePanelDifficultyLevel = parsePanelDifficultyLevel;
const zod_1 = require("zod");
exports.PanelDifficultyLevelSchema = zod_1.z.object({
  id: zod_1.z.number(),
  code: zod_1.z.string(),
  title_en: zod_1.z.string(),
  title_ru: zod_1.z.string(),
  active: zod_1.z.boolean(),
  level_category_id: zod_1.z.number(),
  sort_order: zod_1.z.number(),
  title: zod_1.z.string()
});
function parsePanelDifficultyLevel(values) {
  return exports.PanelDifficultyLevelSchema.parse(values);
}
